import * as React from "react";
import { Tooltips } from ".";

export const SettingFoundation: React.FC<{}> = () => {
  return (
    <div className="row">
      <div className="col-md-6">
        <p>
          A health policy is a written document that formalises an
          organisation’s ongoing commitment to improving health and wellbeing in
          the workplace.
          <Tooltips id={24} /> When developing a workplace health policy, it is
          important to:
        </p>
        <ul className="bullet-fulcrum bullet-gold mb-4">
          <li>
            <p>Speak to staff, so that they feel involved in the process.</p>
          </li>
          <li>
            <p>
              Gain support from all levels of management, so that they can 'walk
              the talk' and support/promote your policy and program objectives.
            </p>
          </li>
        </ul>
        <p>Health policy can be developed in several ways:</p>
        <ul className="bullet-fulcrum bullet-gold mb-4">
          <li>
            <p>
              Overarching{" "}
              <a
                href="https://cdn.livelighter.com.au/assets/resource/workplace/2021-07-creating-a-workplace-health-policy.docx"
                className="text-reset text-underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Health and Wellbeing Policy
              </a>{" "}
              targeting a range of risk factors.
            </p>
          </li>
          <li>
            <p>
              Stand alone policies targeting specific health areas (e.g. a
              physical activity policy, a healthy catering policy, a smoke-free
              policy and/or an alcohol policy)
            </p>
          </li>
          <li>
            <p>
              If your organisation does not want to create new policies, you
              could include health policy items within an existing health
              related policy (e.g. a Fitness for work policy or an Occupational
              safety and health policy)
            </p>
          </li>
        </ul>
      </div>
      <div className="col-md-6">
        <p>A good health and wellbeing policy should:</p>
        <ul className="bullet-fulcrum bullet-gold mb-4">
          <li>
            <p>
              Provide clear messages about the organisation’s stance on health
              and wellbeing.
            </p>
          </li>
          <li>
            <p>
              Guide decisions related to health and wellbeing in the workplace.
            </p>
          </li>
          <li>
            <p>
              Provide a foundation for creating, implementing and reviewing
              health and wellbeing strategies.
            </p>
          </li>
        </ul>
        <p>
          Health policy is about encouraging and supporting staff to make
          healthy choices. For example, a healthy catering policy may state that
          at least 50% of the food provided at workplace functions (meetings and
          events) or at an on-site cafe must be healthy.
        </p>
        <p>
          Policy also allows you to ensure that the workplace is not enabling
          unhealthy behaviours. For example, limiting the number of alcoholic
          drinks offered at work functions to no more than two per person or
          introducing a smoke-free workplace policy.
        </p>
      </div>
    </div>
  );
};
